import { useRef, useState } from "react";
import { Document, Page } from "react-pdf";

import { Spinner } from "../Spinner";
import styles from "./style.module.scss";

interface IPDFViewer {
    /**
     * PDF document string
     */
    document: string;
}
/**
 * PDF viewer - Scale on parent WIDTH
 */
const PDFViewer = ({ document }: IPDFViewer) => {
    const [numPages, setNumPages] = useState<number>();
    const agContainerRef = useRef<HTMLDivElement>(null);

    const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
        setNumPages(numPages);
    };

    return (
        <div className={styles["responsive-pdf"]} ref={agContainerRef}>
            <Document
                file={`data:application/pdf;base64,${document}`}
                onLoadSuccess={onDocumentLoadSuccess}
                className={styles["document"]}
                loading={
                    <div className={styles["loading"]}>
                        <Spinner />
                    </div>
                }
            >
                {Array.apply(null, Array(numPages))
                    .map((x, i) => i + 1)
                    .map((page) => (
                        <Page
                            renderAnnotationLayer={false}
                            pageNumber={page}
                            width={agContainerRef?.current?.offsetWidth}
                            key={`page${page}o${numPages}`}
                        />
                    ))}
            </Document>
        </div>
    );
};

export default PDFViewer;
